'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodashEs = require('lodash-es');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Pomocný objekt pro odesílání focus/blur událostí ze složeného formulářového pole.
 */
var CompositeFocusBlur = function () {

    /**
     * Konstruktor.
     *
     * @param {object} target - nadřazená react komponenta, která má v props callback onFocus a onBlur
     * @param {object} [options] - extra parametry
     * @param {number} [options.delay=100] - prodleva (v ms) před vyvoláním onFocus/onBlur nadřazené komponenty
     */
    function CompositeFocusBlur(target) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheck3.default)(this, CompositeFocusBlur);
        this.handlers = {
            onFocus: function onFocus() {
                _this.counter++;
                _this.checkLater();
            },
            onBlur: function onBlur() {
                _this.counter--;
                _this.checkLater();
            }
        };
        var _options$delay = options.delay,
            delay = _options$delay === undefined ? 100 : _options$delay;


        this.target = target;
        this.counter = 0;
        this.prevCounter = 0;
        this.checkLater = (0, _lodashEs.debounce)(function () {
            return _this.check();
        }, delay);
    }

    /**
     * Handlery, které se předají polím nadřazené komponenty.
     */


    (0, _createClass3.default)(CompositeFocusBlur, [{
        key: 'check',
        value: function check() {
            var counter = this.counter;

            if (counter !== this.prevCounter) {
                this.prevCounter = counter;
                if (counter > 0) {
                    this.target.props.onFocus();
                } else {
                    this.target.props.onBlur();
                }
            }
        }
    }]);
    return CompositeFocusBlur;
}();

exports.default = CompositeFocusBlur;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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